import { render } from "./FileIcons.vue?vue&type=template&id=717af233&scoped=true"
import script from "./FileIcons.vue?vue&type=script&lang=js"
export * from "./FileIcons.vue?vue&type=script&lang=js"

import "./FileIcons.vue?vue&type=style&index=0&id=717af233&scoped=true&lang=css"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717af233"]])

export default __exports__